import '@vaadin/custom-field';
import '@vaadin/icon';
import '@vaadin/icons';
import { componentName, MappingsFieldClass } from './MappingsFieldClass';
import '@descope-ui/descope-text';
import '@descope-ui/descope-button';
import '../../descope-text-field';
import '@descope-ui/descope-combo-box';
import './descope-mappings-field-internal';
import './descope-mapping-item';

customElements.define(componentName, MappingsFieldClass);

export { MappingsFieldClass, componentName };
